import styled from 'styled-components';
export const Copy = styled.span `
  display: block;
  ${({ theme: { attendeesHeaderCopy } }) => attendeesHeaderCopy}
`;
export const Title = styled.span `
  display: block;
  margin-bottom: .5rem;
  ${({ theme: { attendeesHeaderTitle } }) => attendeesHeaderTitle}
`;
export const Wrapper = styled.div `
  display: block;
  background-color: white;
  width: 100%;
  border: none;
  padding: 1.1rem 1rem 1.2rem;
  text-align: left;
  ${({ theme: { attendeesHeader } }) => attendeesHeader}
`;
